/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  FraxUsdcPoolLib,
  FraxUsdcPoolLibInterface,
} from "../FraxUsdcPoolLib";

const _abi = [
  {
    inputs: [],
    name: "FRAX_INDEX",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UNKNOWN_AMOUNT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDC_INDEX",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60ba610039600b82828239805160001a60731461002c57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe730000000000000000000000000000000000000000301460806040526004361060455760003560e01c806173f414604a5780638474e641146064578063c38cff9a14607d575b600080fd5b6051600181565b6040519081526020015b60405180910390f35b606b600081565b604051600f9190910b8152602001605b565b606b60018156fea26469706673582212205816f08d60a17565827374f7d6789056ef9e5bbef4b54825565083c777671b6d64736f6c634300080d0033";

type FraxUsdcPoolLibConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: FraxUsdcPoolLibConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class FraxUsdcPoolLib__factory extends ContractFactory {
  constructor(...args: FraxUsdcPoolLibConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "FraxUsdcPoolLib";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FraxUsdcPoolLib> {
    return super.deploy(overrides || {}) as Promise<FraxUsdcPoolLib>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FraxUsdcPoolLib {
    return super.attach(address) as FraxUsdcPoolLib;
  }
  connect(signer: Signer): FraxUsdcPoolLib__factory {
    return super.connect(signer) as FraxUsdcPoolLib__factory;
  }
  static readonly contractName: "FraxUsdcPoolLib";
  public readonly contractName: "FraxUsdcPoolLib";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FraxUsdcPoolLibInterface {
    return new utils.Interface(_abi) as FraxUsdcPoolLibInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FraxUsdcPoolLib {
    return new Contract(address, _abi, signerOrProvider) as FraxUsdcPoolLib;
  }
}
